import styled from "styled-components";

export const Container = styled.div`
  margin-bottom: 0.5rem;

  .titulo {
    margin-bottom: 0.3rem;
  }

  .Etapa_div_addRecursos {
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: space-between;

    select {
      width: 100%;
      margin-right: 1rem;
    }
  }
`;
